function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../utils/classNames';
var cx;
/**
 * The MediaFrame component is responsible for saving space and arranging
 * the placement of an image within it's "frame". The MediaFrame component
 * can be used with components that are not Images or Videos too.
 * When using with Images or Videos you should prefer using the `Media`
 * component.
 *
 * ## Related Components
 * - [Media](../Media/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <MediaFrame
 *   width={100}
 *   aspectRatio="1:1"
 * >
 *   <span>Some Text</span>
 * </MediaFrame>
 *```
 *
 * With Image (Prefer Media component)
 *
 * ```jsx
 * <MediaFrame
 *   width={100}
 *   aspectRatio="1:1"
 * >
 *   <Image src="https://myimg.com/img.jpg" alt="description of image" />
 * </MediaFrame>
 * ```
 *
 * ## Props
 */

var MediaFrame = /*#__PURE__*/function (_PureComponent) {
  _inherits(MediaFrame, _PureComponent);

  var _super = _createSuper(MediaFrame);

  function MediaFrame() {
    _classCallCheck(this, MediaFrame);

    return _super.apply(this, arguments);
  }

  _createClass(MediaFrame, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          className = _this$props.className,
          width = _this$props.width,
          height = _this$props.height,
          aspectRatio = _this$props.aspectRatio,
          children = _this$props.children,
          forwardedRef = _this$props.forwardedRef,
          customProps = _objectWithoutProperties(_this$props, ["qa", "className", "width", "height", "aspectRatio", "children", "forwardedRef"]);

      var _MediaFrame$getClassN = MediaFrame.getClassName({
        className: className,
        aspectRatio: aspectRatio
      }),
          root = _MediaFrame$getClassN.root,
          placeholder = _MediaFrame$getClassN.placeholder;

      var childrenAsLayer = Children.toArray(children).map(function (c) {
        if (c.props) {
          var childClassName = c.props.className;
          var hasOwnPlacement = /(center|right|left|bottom|top)/.test(childClassName);
          return /*#__PURE__*/cloneElement(c, {
            className: cx(childClassName, {
              'psw-layer': !hasOwnPlacement
            }),
            children: c.props.children
          });
        }

        return /*#__PURE__*/React.createElement("span", {
          className: "psw-layer"
        }, c);
      });

      var node = customProps.node,
          fit = customProps.fit,
          place = customProps.place,
          debug = customProps.debug,
          restOfProps = _objectWithoutProperties(customProps, ["node", "fit", "place", "debug"]);

      return /*#__PURE__*/React.createElement("span", _extends({
        ref: forwardedRef,
        "data-qa": qa,
        style: {
          width: width,
          minWidth: width,
          height: height
        },
        className: "".concat(root, " ").concat(placeholder)
      }, restOfProps), childrenAsLayer);
    }
  }]);

  return MediaFrame;
}(PureComponent);

MediaFrame.mediaFrame = true;
MediaFrame.defaultProps = {
  qa: '',
  className: '',
  width: undefined,
  height: undefined,
  aspectRatio: undefined,
  children: null,
  forwardedRef: null
};
MediaFrame.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Sets the width of the frame
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Sets the height of the frame
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Aspect ratio to restrict the image to. Aspect ratios are defined in
   * the base styles package
   */
  aspectRatio: PropTypes.oneOf([undefined, '1:1', '4:3', '20:9', '16:9', '3:2', '2:3', '3:4', '8:5', '4:5', '5:6']),

  /**
   * Content to restrict within the frame component
   */
  children: PropTypes.node,
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })])
};

MediaFrame.getClassName = function (_ref) {
  var className = _ref.className,
      _ref$aspectRatio = _ref.aspectRatio,
      aspectRatio = _ref$aspectRatio === void 0 ? '' : _ref$aspectRatio;
  return {
    root: cx('psw-media-frame', 'psw-fill-x', className),
    placeholder: cx(_defineProperty({}, "psw-aspect-".concat(aspectRatio.replace(':', '-')), !!aspectRatio))
  };
};

MediaFrame.useClassNames = function (classNames) {
  MediaFrame.classNames = classNames;
};

cx = classNamesFor(MediaFrame);
export default MediaFrame;